import React, {useRef, useEffect, useState} from 'react';
import {Player} from "@lottiefiles/react-lottie-player";
import loadingAnim from "./loading.json"

const RaikoVideoThumbnailGenerator = ({videoUrl, seekTime = 5}) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [thumbnailUrl, setThumbnailUrl] = useState('');

    useEffect(() => {
        /*const video = videoRef.current;
        const canvas = canvasRef.current;

        if (video && canvas) {
            video.src = videoUrl;

            // Ensure the video is loaded and ready to capture a frame
            video.addEventListener('loadeddata', () => {
                // Wait for the video to be ready to play
                video.addEventListener('canplay', () => {
                    // Seek to the specified time (e.g., 5 seconds)
                    video.currentTime = seekTime;
                });

                // Capture the frame when the video seek is complete
                video.addEventListener('seeked', () => {
                    // Set the canvas dimensions to the video dimensions
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;

                    // Draw the video frame to the canvas
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                    // Convert the canvas image to a data URL and set it as the thumbnail
                    const dataUrl = canvas.toDataURL();
                    setThumbnailUrl(dataUrl);
                });
            });

            // Handle errors (e.g., CORS issues or invalid video URLs)
            video.addEventListener('error', (e) => {
                console.error('Error loading video:', e);
            });
        }*/
    }, [videoUrl, seekTime]);

    return (
        <div>
            {/* Hidden video element to load the video */}
            <video ref={videoRef} style={{display: 'none'}} crossOrigin="anonymous"/>
            {/* Hidden canvas element to draw the frame */}
            <canvas ref={canvasRef} style={{display: 'none'}}/>
            {/* Display the thumbnail if generated */}
            {thumbnailUrl ? (
                <img src={thumbnailUrl} alt="Video Thumbnail"/>
            ) : (
                <div className={"mainImageCropped"}>
                    <Player
                        src={loadingAnim}
                        loop
                        autoplay
                        style={{height: '80px', width: '80px'}}
                    />
                </div>
            )}
        </div>
    );
};

export default RaikoVideoThumbnailGenerator;